/** @format */

import React, { useEffect, lazy, Suspense } from 'react';
import { Grid } from '@mui/material';
import { useStyles } from './style';
import clsx from 'clsx';
import { Helmet } from 'react-helmet';
import Services from './services';
import { Card, CardContent } from '@mui/material';
import useCustomHook from './hooks';
import { useCurrencyUnit } from 'hooks';

const BusinessInfo = lazy(() => import('./components/BusinessInfo'));
const Chart = lazy(() => import('./components/Chart'));
const Accounts = lazy(() => import('./components/Accounts'));

const Dashboard = (props) => {
  const {
    creditLoading,
    setCreditLoading,
    accounts,
    setAccounts,
    walletBalance,
    setWalletBalance,
    balance,
    setBalance,
    withdrawableBalance,
    setWithdrawableBalance,
    showSayyah,
    setShowSayyah,
  } = useCustomHook();
  const { className } = props;
  const classes = useStyles();
  const currencyText = useCurrencyUnit();

  useEffect(() => {
    getCredit();
  }, []);
  const getFeature = async () => {
    setCreditLoading(true);

    try {
      const result = await Services.getFeatureList();

      const features = result?.result ?? []; // همون لیست رشته‌ها

      const hasSayyah = features.includes('sayyah');

      setShowSayyah(hasSayyah);
    } catch (error) {
      setShowSayyah(false);
    } finally {
      setCreditLoading(false);
    }
  };

  const getCredit = async () => {
    try {
      setCreditLoading(true);
      const result = await Services.getCredit();
      const tempList = result?.result?.mainBusinessAmountSrvs ?? [];

      computeTotalBalances(tempList);

      setAccounts(result?.result?.customerAmountSrvs[0]);
      setWalletBalance(result?.result?.customerAmountSrvs[0]?.amount);
      getFeature();
    } catch (error) {
      setCreditLoading(false);
    }
  };

  const title = 'میز کار';

  const computeTotalBalances = (allGuilds) => {
    if (!allGuilds) return;
    let tempBalance = 0;
    let tempWithdrawableBalance = 0;

    allGuilds?.forEach((guild) => {
      if (guild?.amount) {
        tempBalance += guild?.amount;
      }
      if (guild?.withdrawableAmount) {
        tempWithdrawableBalance += guild?.withdrawableAmount;
      }
    });

    setBalance(tempBalance ?? 0);
    setWithdrawableBalance(tempWithdrawableBalance ?? 0);
  };

  return (
    <div className={classes.root}>
      <Helmet>
        <title>{title ? `پنل کسب‌وکار پاد :: ${title}` : 'پنل کسب‌وکار پاد'}</title>
      </Helmet>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6} className={classes.rightWrapper}>
          <Suspense
            fallback={
              <Card className={clsx(classes.Suspense, className)}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ marginBottom: 16 }}
                >
                  <CardContent>
                    <div>بارگذاری...</div>
                  </CardContent>
                </Grid>
              </Card>
            }
          >
            <BusinessInfo showSayyah={showSayyah} />
          </Suspense>
        </Grid>
        <Grid item xs={12} md={6}>
          {/* <Requests /> */}
          <Suspense
            fallback={
              <Card className={clsx(classes.Suspense, className)}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ marginBottom: 16 }}
                >
                  <CardContent>
                    <div>بارگذاری...</div>
                  </CardContent>
                </Grid>
              </Card>
            }
          >
            <Accounts
              loading={creditLoading}
              accounts={accounts}
              balance={balance}
              withdrawableAmount={withdrawableBalance}
              creditLoading={creditLoading}
              walletBalance={walletBalance}
              currencyText={currencyText}
            />
          </Suspense>
        </Grid>
      </Grid>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Suspense
            fallback={
              <Card className={clsx(classes.Suspense1, className)}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ marginBottom: 16 }}
                >
                  <CardContent>
                    <div>بارگذاری...</div>
                  </CardContent>
                </Grid>
              </Card>
            }
          >
            <Chart DepositType={true} />
          </Suspense>
        </Grid>
        <Grid item xs={12} md={6}>
          <Suspense
            fallback={
              <Card className={clsx(classes.Suspense1, className)}>
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  style={{ marginBottom: 16 }}
                >
                  <CardContent>
                    <div>بارگذاری...</div>
                  </CardContent>
                </Grid>
              </Card>
            }
          >
            <Chart DepositType={false} />
          </Suspense>
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
